module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Edit Segment")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-sm-12 py-3"
  }, [_c('segments-form', {
    attrs: {
      "segment": _vm.tempSegment
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center justify-content-end",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4f09c343", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f09c343"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/segments/editSegment.vue
// module id = 2370
// module chunks = 0